import {ErrorMessage} from 'formik';
import PropTypes from 'prop-types';
import React from 'react';
import CustomErrorMessage from '../CustomErrorMessage';

const FieldWrapper = ({
    name, label, children
}) =>
    (
        <div className="field-wrapper">
            <label htmlFor={name} className="field-wrapper-label">
                {label}
            </label>
            {children}
            <ErrorMessage name={name} component={CustomErrorMessage} />
        </div>
    );

FieldWrapper.propTypes = {
    name: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired
};

export default FieldWrapper;
